export { default as List } from 'inpc/containers/InpcListContainer';
export { default as Form } from 'inpc/containers/InpcFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/containers/index.js